var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMoveLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "88px",
    viewBox: "0 0 88 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PWS-APP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Program---Samples-(CR)---Bulk-Edit-3",
    transform: "translate(-676.000000, -118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog",
    transform: "translate(468.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content-Area"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(24.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(186.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4347826,50.6186441 C41.4347826,41.2157458 49.0653913,33.5932203 58.4782609,33.5932203 C60.0441739,33.5932203 61.5593043,33.8086441 63,34.2033559 L63,28.9859322 C63,27.6926949 61.7728696,26.6440678 60.2584348,26.6440678 L36.1526957,26.6440678 L36.1526957,21.6337288 C36.1526957,20.1792712 34.7718261,19 33.0688696,19 L18.0838261,19 C16.3808696,19 15,20.1792712 15,21.6337288 L15,26.6440678 L15,57.6456271 C15,58.9458136 16.234087,60 17.7561739,60 L44.2570435,60 C42.4754783,57.3099831 41.4347826,54.0862712 41.4347826,50.6186441",
    id: "Fill-1",
    fill: "#04B5E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5539024,57.6127805 L59.0536829,56.112561 L63.615878,51.5503659 L51.3234146,51.5503659 L51.3234146,49.4284146 L63.615878,49.4284146 L59.0536829,44.8662195 L60.5539024,43.3652927 L67.6772927,50.4893902 L60.5539024,57.6127805 Z M59.5,36 C51.4917561,36 45,42.4917561 45,50.5 C45,58.5089512 51.4917561,65 59.5,65 C67.5082439,65 74,58.5089512 74,50.5 C74,42.4917561 67.5082439,36 59.5,36 L59.5,36 Z",
    id: "Fill-3",
    fill: "#002C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,42 C84,65.1958017 65.1958017,84 42,84 C18.8035041,84 0,65.1958017 0,42 C0,18.8041983 18.8035041,0 42,0 C65.1958017,0 84,18.8041983 84,42 Z",
    id: "Stroke-5",
    stroke: "#002C8B",
    strokeWidth: 3
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoveLocation);
export default __webpack_public_path__ + "static/media/icon-move-location.7a180b14.svg";
export { ForwardRef as ReactComponent };